var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramCash48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./Cash48*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Note",
    transform: "translate(3.750000, 12.750000)",
    stroke: "#4F4C4D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 1,
    y: 1,
    width: 38.5,
    height: 20.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Strip",
    fill: "#FFCC00",
    x: 11,
    y: 1,
    width: 8.5,
    height: 20.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "$",
    transform: "translate(29.250000, 4.250000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,9.75 L3.75156525,9.75 M4.125,6 L3.375,6 M2.99843484,2.25 L5.25000009,2.25",
    id: "Arms"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625,2.25 C1.58946609,2.25 0.75,3.08946609 0.75,4.125 C0.75,5.16053391 1.58946609,6 2.625,6",
    id: "Curve"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.375,6 C5.33946609,6 4.5,6.83946609 4.5,7.875 C4.5,8.91053391 5.33946609,9.75 6.375,9.75",
    id: "Curve-bottom",
    transform: "translate(5.437500, 7.875000) scale(-1, 1) translate(-5.437500, -7.875000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75,2.25 L3.75,0",
    id: "Stick-top"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75,12 L3.75,9.75",
    id: "Stick-bottom"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramCash48);
export default __webpack_public_path__ + "static/media/pictogramCash48.c0269f77b5286fd068c0d510b95b335f.svg";
export { ForwardRef as ReactComponent };